import React from 'react';

// Components
import ProfileTabSection from '../../../components/Profile/ProfileTabSection';
import ProfileDataBlock from '../../../components/Profile/ProfileDataBlock';

const PlayerProfileCamps = ({ camps }) => (
  <ProfileTabSection heading="Camps" >
    <ProfileDataBlock heading="" >
      <ul>
        {
          camps.map((camp, index) => <li key={camp + index}><p>{camp}</p></li>)
        }
      </ul>
    </ProfileDataBlock>
  </ProfileTabSection>
)

export default PlayerProfileCamps;



// WEBPACK FOOTER //
// ./src/screens/Profile/ProfileSections/PlayerProfileCamps.js